<fab-loading-spinner *ngIf="isPageLoading"></fab-loading-spinner>
<mat-dialog-content *ngIf="!isPageLoading">

    <h1 class="header">Employee Vacation Allowance Override</h1>
    <div fxLayout="row" fxLayoutAlign="center">
        <mat-card>
            <mat-card-content>
                <table class="top-tables">
                    <tr>
                        <th id="name" class="top-table-headings">Employee Name</th>
                        <td>{{selectedData[0].firstName | titlecase}} {{selectedData[0].lastName | titlecase}}</td>
                    </tr>
                    <tr>
                        <th id="gmin" class="top-table-headings">GMIN</th>
                        <td>{{selectedData[0].gmin}}</td>
                    </tr>
                    <tr>
                        <th id="vac-allowance" class="top-table-headings">Vacation Allowance </th>
                        <td>{{this.selectedData[0].vacationAllowance}}</td>
                    </tr>
                    <tr>
                        <th id="remaining" class="top-table-headings">Remaining Days </th>
                        <td>{{this.selectedData[0].vacationAllowanceRemaining}}</td>
                    </tr>
                    <tr>
                        <th id="carry-over" class="top-table-headings">Carry Over</th>
                        <td>{{this.selectedData[0].vacationAllowanceCarryover}}</td>
                    </tr>
                </table>
            </mat-card-content>
        </mat-card>
    </div>
    <br/>
    <div fxLayout="row" fxLayoutAlign="center">
        <form fxLayout="column" fxLayoutAlign="center" (ngSubmit)="submitForm()" #form="ngForm">
            <table>
                <tr>
                    <th id="override">Override:</th>
                    <td>
                        <mat-form-field appearance="outline">
                            <mat-label>Please select an override type</mat-label>
                            <mat-select id="vacationType" name="vacationType" [(ngModel)]="overrideType" #override required>
                                <mat-option *ngFor="let overrideOptions of overrideOptions" [value]="overrideOptions.value">
                                    {{overrideOptions.displayValue}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </td>
                </tr>
                <tr *ngIf="override.value === 'allowance'">
                    <th id="value">Value:</th>
                    <td>
                        <mat-form-field appearance="outline">
                            <input matInput type="number" id="allowance" [(ngModel)]="selectedData[0].vacationAllowance" name="allowance"
                                   [valueAsNumber]="newAllowance"/>
                        </mat-form-field>
                    </td>
                </tr>
                <tr *ngIf="override.value === 'carry_over'">
                    <th id="value-carry-over">Value:</th>
                    <td>
                        <mat-form-field appearance="outline">
                            <input matInput type="number" id="carry_over" [(ngModel)]="selectedData[0].vacationAllowanceCarryover" name="carry_over"
                                   [valueAsNumber]="newCarryOver"/>
                        </mat-form-field>
                    </td>
                </tr>
            </table>
            <button mat-raised-button color="primary" [disabled]="!form.form.valid">Submit</button>
        </form>
    </div>
</mat-dialog-content>
